export type FeedbackCategory =
  | 'general_inquiry'
  | 'technical_support'
  | 'billing_issue'
  | 'feature_request'
  | 'bug_report'
  | 'account_issue'
  | 'other';

export interface FeedbackRequest {
  category: FeedbackCategory;
  // Optional: the API derives the subject from the message server-side. Only
  // seeded by entry points like the Pro Plan / pro inquiry link.
  subject?: string;
  message: string;
  attachment_ids?: string[];
}

export interface FeedbackResponse {
  ticket_number: string;
  status: string;
  created_at: string;
}

export interface SupportTicketAttributes {
  user_name: string;
  user_email: string;
  // Optional: the API derives the subject from the message when omitted.
  subject?: string;
  message: string;
  category: FeedbackCategory;
  channel: 'web';
  attachment_ids?: string[];
}

export interface SupportTicketData {
  type: 'support-ticket';
  attributes: SupportTicketAttributes;
}

export interface SupportTicketRequest {
  data: SupportTicketData;
}

export interface SupportTicketResponse {
  data: {
    type: 'support-ticket';
    id: string;
    attributes: FeedbackResponse;
  };
}

export const FEEDBACK_CATEGORIES: Record<FeedbackCategory, string> = {
  general_inquiry: 'General Inquiry',
  technical_support: 'Technical Support',
  billing_issue: 'Billing Issue',
  feature_request: 'Feature Request',
  bug_report: 'Bug Report',
  account_issue: 'Account Issue',
  other: 'Other',
};

export const MIN_MESSAGE_LENGTH = 10;
export const MAX_MESSAGE_LENGTH = 5000;
export const MAX_ATTACHMENTS = 5;
